import { useCallback, useEffect } from 'react';
import { usePromiseCallback } from './use-promise-callback';
import { IUsePromiseOptions, IUsePromiseResult } from './types';

const DefaultOptions: IUsePromiseOptions = {
  manual: false,
};

export const usePromise = <T>(getPromise: () => Promise<T>, dependencies: any[], options: IUsePromiseOptions = DefaultOptions): IUsePromiseResult<T> => {
  const { execute, ...requestData } = usePromiseCallback<T>(getPromise as any, dependencies, options);
  const executeWithPromiseCounterManipulation = useCallback(
    () => { execute({ manipulatePromiseCounter: true }); },
    [execute],
  );
  useEffect(executeWithPromiseCounterManipulation, dependencies);

  return requestData;
};
